import { Component, HostListener, Input, Output, EventEmitter, OnInit, ChangeDetectorRef } from '@angular/core';
import { WebSiteService } from '../services/website-service';
import { forkJoin } from 'rxjs';
import { Cultures } from '../../admin/models/cultures.const';
import { Router } from '@angular/router';
import { MenuTreeViewModel } from '../../admin/models/menu/menu-tree-view.model';

@Component({
  // tslint:disable-next-line: component-selector
  selector: 'nav[m-app-nav-menu]',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit {
  currentElement: Element;
  currentDivElement: Element;

  toogled: boolean;
  languages: any;
  menu: any;
  menuLanguageText: any;
  loading: boolean;
  searchText: string;
  searchBarPlaceHolder: string = '';

  constructor(
    private webSiteService: WebSiteService,
    private router: Router,
    private cd: ChangeDetectorRef
  ) {

  }

  ngOnInit(): void {
    forkJoin(
      this.webSiteService.getMenus(),
      this.webSiteService.getLanguages())
      .subscribe(resp => {
        this.menu = this.listToTree(resp[0].menu);
        this.searchBarPlaceHolder = resp[0].searchBarPlaceHolder;
        this.languages = resp[1].data;
        this.menuLanguageText = localStorage.getItem('current-language') || Cultures.tr;
        this.cd.detectChanges();
      });
  }

  public closeOpened() {
    if (this.currentDivElement) {
      this.currentDivElement.classList.remove('show');
    }
    if (this.currentElement) {
      this.currentElement.classList.remove('show');
    }
  }

  toogle() {
    document.getElementsByTagName('html')[0].className = this.toogled ? '' : 'nav-open';
    this.toogled = !this.toogled;
  }

  @HostListener('document:click', ['$event'])
  DocumentClick(event: MouseEvent) {
    this.closeOpened();
    const target = event.target as HTMLElement;
    const div = target.parentElement && target.parentElement.querySelector('.dropdown-menu.dropdown-with-icons');

    if (this.currentElement !== target.parentElement && target.className.indexOf('nav-link') !== -1 && div) {
      div.classList.add('show');
      target.parentElement.classList.add('show');
      this.currentElement = target.parentElement;
      this.currentDivElement = div;

      return;
    }

    this.currentElement = undefined;
    this.currentDivElement = undefined;
  }

  public onChangeofOptions(name) {
    localStorage.setItem('current-language', name);
    location.reload();
  }

  public listToTree(list: MenuTreeViewModel[]) {
    const map = {};
    const roots: MenuTreeViewModel[] = [];

    for (let i = 0; i < list.length; i++) {
      map[list[i].id] = i;
      list[i].children = [];
    }
    for (let i = 0; i < list.length; i++) {
      const node = list[i];
      if (node.parentId !== null) {
        const parent = list[map[node.parentId]];

        parent.children.push(node);
        node.parent = parent;
      } else {
        roots.push(node);
      }
    }

    return this.sortList(roots);
  }

  public sortList(list: MenuTreeViewModel[]): any {
    const result = list.sort(function (a, b) {
      return a.priority - b.priority;
    });

    result.forEach(menu => {
      menu.children = this.sortList(menu.children);
    });

    return result;
  }

  search(form, $event) {
    $event.preventDefault();
    if (form.valid) {
      this.router.navigate(['search'], {
        queryParams: {
          keys: this.searchText
        }
      });
    }
  }
}
